module.exports = __webpack_public_path__ + "img/Desk Stationary A40.fc602f0e.jpg";